import CurrencyPerformanceChart from "./charts/CurrencyPerformanceChart";
import CurrencyTrendChart from "./charts/CurrencyTrendChart";

export default function CurrencyCharts() {
    return (
        <div className="w-full grid grid-cols-3 gap-4">
            <div className="col-span-2">
                <CurrencyTrendChart />
            </div>
            <div className="col-span-1">
                <CurrencyPerformanceChart />
            </div>
        </div>
    );
}